var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_843",
    "data-name": "Group 843",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.001,
    height: 32,
    viewBox: "0 0 32.001 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M1252.991,3885.287h-14.34a8.841,8.841,0,0,0-8.831,8.831v14.339a8.84,8.84,0,0,0,8.831,8.831h14.34a8.842,8.842,0,0,0,8.83-8.831v-14.339a8.84,8.84,0,0,0-8.83-8.831Zm5.992,23.169a6,6,0,0,1-5.992,5.991h-14.34a6,6,0,0,1-5.991-5.991v-14.339a6,6,0,0,1,5.991-5.991h14.34a6,6,0,0,1,5.992,5.991Zm0,0",
    transform: "translate(-1229.82 -3885.287)",
    fill: "#fd930d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M1243.392,3890.614a8.246,8.246,0,1,0,8.248,8.243,8.256,8.256,0,0,0-8.248-8.243Zm0,13.651a5.405,5.405,0,1,1,5.408-5.407,5.413,5.413,0,0,1-5.408,5.407Zm0,0",
    transform: "translate(-1227.391 -3882.859)",
    fill: "#fd930d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M1247.362,3888.96a2.081,2.081,0,1,0,1.472.609,2.1,2.1,0,0,0-1.472-.609Zm0,0",
    transform: "translate(-1222.769 -3883.613)",
    fill: "#fd930d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.85fdbe4368c39267ed331f4b8046a592.svg";
export { ForwardRef as ReactComponent };